<template>
  <div class="search-container">
    <div class="hidden-sm-and-up menu-filter">
      <el-button
        class="btn-filter"
        @click="showFilter"><i class="icon-sliders"/>Filtrar
      </el-button>
    </div>
    <div class="breadcrumb breadcrumb-search-page">
      <el-breadcrumb separator-class="icon-bullet-icon">
        <el-breadcrumb-item :to="{ name: 'Home' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Búsqueda</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="grid-container">
      <el-row class="grid-content">
        <el-col
          :xs="6"
          :sm="6"
          :md="6"
          :lg="6"
          :xl="6"
          class="hidden-xs-only">
          <div class="input-search">
            <el-input
              prefix-icon="icon-search"
              placeholder="Buscar"
              @input="defaultSearchFunction"/>
          </div>
          <br>
          <div class="category-filter">
            <ul>
              <li class="music">
                <div class="style">
                  <i class="icon-music-icon"/>Música
                </div>
                <div class="widht-50">
                  <el-tag>240</el-tag>
                </div>
              </li>
              <li class="sports">
                <div class="style">
                  <i class="icon-sports-icon"/>Deportes
                </div>
                <div class="widht-50">
                  <el-tag>240</el-tag>
                </div>
              </li>
              <li class="arts">
                <div class="style">
                  <i class="icon-arts-icon"/>Arte y cultura
                </div>
                <div class="widht-50">
                  <el-tag>240</el-tag>
                </div>
              </li>
              <li class="kids">
                <div class="style">
                  <i class="icon-kids-icon"/>Niños
                </div>
                <div class="widht-50">
                  <el-tag>240</el-tag>
                </div>
              </li>
              <li class="special">
                <div class="style">
                  <i class="icon-special-icon"/>Especiales
                </div>
                <div class="widht-50">
                  <el-tag>240</el-tag>
                </div>
              </li>
            </ul>
          </div>
          <br>
          <div>
            <el-select
              v-model="value"
              placeholder="Selecciona un estado">
              <el-option
                v-for="item in statesMexico"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </div>
          <br>
          <div/>
          <br>
          <br>
          <mt-secure-buy/>
        </el-col>
        <el-col
          :offset="1"
          :xs="24"
          :sm="17"
          :md="17"
          :lg="17"
          :xl="17"
          class="card-container">
          <el-col class="first-search">
            <div class="search-result">
              Término de búsqueda ( <b>{{ getAllEvents.length }}</b> resultados )
            </div>
            <div class="group-by">
              <div class="title">
                <h1>Ordenar por:</h1>
              </div>
              <el-select
                v-model="valueTwo"
                placeholder="Selecciona">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
              </el-select>
            </div>
          </el-col>
          <el-col
            class="content-card">
            <card-event
              v-for="(card, index) in getAllEvents"
              :key="index"
              :category="card.category.parentId"
              :data="card"/>
            <mt-secure-buy class="hidden-sm-and-up"/>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <!--FILTERS-->
    <div
      v-show="showFilters"
      class="filters">
      <div class="header">
        <div>
          <i
            class="icon-arrow-left"
            @click="showFilter"/>
        </div>
        <div>
          <el-button type="text">Limpiar</el-button>
          <el-button type="text">Filtrar</el-button>
        </div>
      </div>
      <div class="filters-content">
        <div class="category-event">
          <div class="buttons">
            <el-button circle><i class="icon-music-icon"/></el-button>
            <el-button circle><i class="icon-sports-icon"/></el-button>
            <el-button circle><i class="icon-kids-icon"/></el-button>
            <br><br>
            <el-button circle><i class="icon-special-icon"/></el-button>
            <el-button circle><i class="icon-arts-icon"/></el-button>
          </div>
        </div>
        <div>
          <el-select
            v-model="value"
            placeholder="Estados">
            <el-option
              v-for="item in statesMexico"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </div>
        <div class="date-picker">
          <el-date-picker
            type="date"
            placeholder="Fecha"/>
        </div>
        <div class="tags">
          <span>Etiquetas</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mtSecureBuy from '../_shared/mt-secure-buy'
import cardEvent from '../_shared/mt-card-event'
import states from '../_shared/states/states'
export default {
  name: 'SearchPage',
  components: {
    mtSecureBuy, cardEvent
  },
  data () {
    return {
      statesMexico: states.states,
      date: '',
      options: [{
        value: 'relevante',
        label: 'Mas relevante'
      }, {
        value: 'nombre',
        label: 'Nombre'
      }
      ],
      valueTwo: '',
      value: '',
      showFilters: false,
      presentationsEvents: {},
      categoriesId: {}
    }
  },
  computed: {
    getAllEvents () {
      return this.$store.getters['events/items']
    }
  },
  mounted () {

  },
  methods: {
    showFilter () {
      this.showFilters = !this.showFilters
    },
    /// SEARCH FUNCTION //
    defaultSearchFunction (val) {
      let _defaultQuery = {}
      let filters = 'filters[where][name][contains]'
      _defaultQuery[filters] = val
      _defaultQuery['with'] = 'category'
      this.executeFilter(_defaultQuery)
    },
    executeFilter (queryValue) {
      let query = Object.assign({}, this.$route.query)
      this.$router.push({ query: { ...query, ...queryValue } })
    }
    /* search (search) {
      if (this.$route.query.product) { delete this.$route.query.product }
      this.$router.push({name: 'products', params: {brandId: 'search'}, query: {...this.$route.query, search: search}})
    } */
  }
}
</script>

<style lang="scss" scoped>

  .widht-50 {
    width: 50%;
  }

  .search-container{
    margin-top: 70px;
    @media #{$iPhoneLandscape} {
      margin-top: 50px;
    }
  }
  .input-search{
    .el-input__inner {
      &:focus{
        border-color: $roseHeader !important;
      }
    }
  }
  .left-col{
    @media #{$Elementxs} {
      display: none;
    }
  }
  .category-filter{
    background-color: white;
    padding: 30px;
    ul{
      list-style-type: none;
      padding-left: 0;
      li{
        i{
          font-size: 24px;
          margin-right: 12px;
        }
        height: 44px;
        display: flex;
        align-items: center;
        cursor: pointer;
        @include font-primary(14px,semibold);
        color: $carbon;
        &:hover{
          color: black;
        }
        .el-tag{
          background-color: #F5F5F5;
          border-radius: 37.5px;
          span{
            @include font-primary(11px !important,semibold);
            color: $dove !important;
          }
        }
      }
    }
  }
.style{
  width: 50%;
  display: flex;
  align-items: center
}
  .music{
    &:hover{
      i{
        color: $music,
      }
      .el-tag{
        background-color: $music;
        color: white !important;
      }
    }
  }
  .sports{
    &:hover{
      i{
        color: $sports,
      }
      .el-tag{
        background-color: $sports;
        color: white !important;
      }
    }
  }
  .arts{
    &:hover{
      i{
        color: $arts,
      }
      .el-tag{
        background-color: $arts;
        color: white !important;
      }
    }
  }
  .kids{
    &:hover{
      i{
        color: $kids,
      }
      .el-tag{
        background-color: $kids;
        color: white !important;
      }
    }
  }
  .special{
    &:hover{
      i{
        color: $special,
      }
      .el-tag{
        background-color: $special;
        color: white !important;
      }
    }
  }

  .first-search {
    width: 100%;
    display: flex;
    @media #{$Elementxs} {
      display: none;
    }
    div{
      width: 50%;
    }
    h1{
      @include font-primary(14px, semibold);
      color: $carbon;
      margin: 0;
    }
    .group-by {
      display: flex;
      .title {
        text-align: right;
        margin-right: 10px;
      }
      .el-select {
        float: right !important;
      }
    }
    .search-result{
      margin-left: 10px;
    }
  }

  .content-card{
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    .card-container{
      margin-bottom: 10px;
      @media #{$iPhone} {
        width: 100%;
      }
    }
  }

  /////////////////////////////////
  /// FILTER MENU       //////////
  ///////////////////////////////

  .menu-filter{
    background-color: $roseHeader;
    height: 50px;
    text-align: right;
    .btn-filter{
      background-color: transparent;
      border: none;
      height: 100%;
      color: white;
      @include font-primary(15px, bold);
      padding: 10px 20px;
      span{
        display: flex !important;
        align-items: center !important;
      }
      i{
        margin-top: 5px;
        margin-right: 12px;
        font-size: 15px;
      }
    }
  }

  .filters {
    background-color: $content;
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    overflow-y: hidden !important;
    z-index: 201;
    .header {
      padding: 0 20px 0 20px;
      display: flex;
      position: fixed;
      z-index: 201;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      background-color: $roseHeader;
      height: 50px;
      color: white !important;
      i {
        font-size: 18px;
      }
      button {
        color: white;
        @include font-primary(12px, bold);
      }
    }
    .filters-content {
      padding: 20px;
      margin-top: 50px;
      .category-event {
        background-color: white;
        width: 100%;
        height: 270px;
        margin-bottom: 3px;
        text-align: center;
        position: relative;
        .buttons {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          padding: 60px;
          button {
            width: 60px;
            height: 60px;
            padding: 0;
            border: 2px solid #707070;
            position: relative;
            span {
              position: absolute;
              bottom: -20px;
              right: 6px;
            }
          }
          i {
            font-size: 36px;
          }
        }
      }
      .tags {
        margin-top: 3px;
        background-color: white;
        height: 140px;
        padding: 16px 20px;
        span{
          @include font-primary(14px, regular);
          color: #777777;
        }
      }
    }
  }

  /////////////////////////////////
  /// RESPONSIVE DESGIN //////////
  ///////////////////////////////

  @media only screen and (max-width: 702px) {
    .card {
      width: 280px !important;
    }
  }

  .card-container {
    @media #{$iPhone} {
      margin-left: 0 !important;
    }
    @media #{$Elementxs} {
      margin-left: 0 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/search-page/search-page.vue